import type { IconProps } from '../types/IconProps.ts';
export const Copy: IconProps = {
    name: 'Copy',
    children: [
        `<path d="M4 16a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2" />`,
        `<rect width="14" height="14" x="8" y="8" rx="2" />`,
    ]
};